import React from 'react'
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from '../../../axios-order.js';
import closeIcon from '../../../Assets/images/close.svg';

class Document extends React.Component{
    state = {
        disable: true,
        error:{ },
        dataFile : [],

    }
    fileChangeHandler =(e)=>{
        let filesData1 = [];
        let filesForm = e.target.files
        for(let k of Object.keys(filesForm)) {
            filesData1.push(filesForm[k])
        }
        this.setState({
            dataFile : filesData1
        },()=>{
            this.props.onSetFile(this.state.dataFile)
        })
    }
    toggleHandler=()=>{
        this.setState({
            disable: !this.state.disable
        })   
    }
    pageChangeHandler=()=>{
        this.props.history.push("/eligibility/education");
    }
    fileRemoveHandler=(index)=>{
        let filesData1 = [...this.state.dataFile]
        filesData1.splice(index, 1)
        this.setState({
            dataFile : filesData1
        },()=>{
            this.props.onSetFile(this.state.dataFile)
        })  
    }
    submitForm=()=>{          
        if(this.state.dataFile.length ===0){
            this.setState({
                error:{
                    file :"Select a file or files to proceed further"
                }
            })
            return false
        }
        else{          
            this.props.onSetLoader();
            axios.post('/case', this.props.person)
            .then( response => { 
                    console.log(response)
                    if(response.status === 200){                     
                        // alert("Your data has been sent!");
                        this.props.onSetLoader();
                        this.props.history.push("/progress");
                    }
            } )
            .catch( error => {            
                alert(error)
                this.props.onSetLoader();
            } );
            return true
        }
    }
   render(){       
    return(
        <div>
              <div className="progressbar-data pb-3 pt-4">
                <div className="progressbar-container">
                        <ul className="progressbar">
                            <li className="active">
                                <div className="pg-text">Personal</div>
                                <div className="pg-text">Details</div>
                            </li>
                            <li  className="active">
                                <div className="pg-text">Education</div>
                                <div className="pg-text">Details</div>
                            </li>
                            <li  className="active">
                                <div className="pg-text active">Documents upload</div>
                                <div className="pg-text active">& Declaration</div>
                            </li>
                            <li>
                                <div className="pg-text">Fees &</div>
                                <div className="pg-text">Charges</div>
                            </li>
                        </ul>
                    </div>    
                </div>
                
                 <form method="post">
                        <div className="form-container mb-4">
                                <h4 className="heading4 text-color2 mb-3 pl-3">Documentation</h4>
                                <div className="my-4">
                                    <div className="form-wrap mc-border">
                                        <h5 className="form-label1">Applications required</h5>                                                    
                                        <div className="mt-4">
                                            <ul className="applicants-rules pl-3">
                                                <li>Copies of education documents including mark sheets transcripts (Matric, Inter, Bachelor, Master) Degrees must be provided.</li>
                                                <li>Recommendation/reference letters from last education provider (1 for undergraduate & 2 for Masters )</li>
                                                <li>Experience certificates (if any)</li>
                                                <li>IELTS/TOEFUPTE results (if available)</li> 
                                                <li>CV + 1 photograph (passport size) • Passport copy</li>
                                            </ul>
                                        </div>     
                                        <div className="form-group mb-0 pl-5">
                                            <input type="file"  hidden name="document" id="files"  multiple onChange={this.fileChangeHandler}/>
                                            <label htmlFor="files" type="button" className="btn btn-docs mr-2">Upload Docs</label>
                                          </div>
                                         <div className="mt-3">
                                              <ul className="mb-0 list-unstyled pl-5">
                                              {this.state.dataFile.map((person, index) => (
                                                    <li key={index} onClick={()=>this.fileRemoveHandler(index)}><span>{person.name}</span>
                                                     <span className="ml-4"><img src={closeIcon} alt="closeicon"  /></span>
                                                    </li>
                                               ))}
                                              </ul>
                                         </div>                                     
                                    </div>
                                {Object.entries(this.state.error).length !==0 ? <div className="mt-2 text-danger">{this.state.error.file}</div> :""}
                                </div>
                                <div className="form-wrap mc-border">
                                    <h5 className="form-label1">Declaration</h5>
                                    <p className="p2 mt-4">I declare that the information I have supplied on and with this form is complete and correct. I understand that my information will be used for admission purposes to universities listed above and/or to other institutions where needed. I consent to the transfer of my information to these institutions. I understand that the giving of flare or incomplete information may lead to refusal of my application or cancellation of my enrolment. I have read, understood and agreed to the terms and conditions of my admissions.</p>
                                    <p className="p2 mt-2 text-danger opactiy-1">I confirm I have read, understood and agree to the declaration above. Type your Name and my Marking this Box.</p>
                                    <div className="mt-2">                                                                        
                                        <label className="checkBox2">
                                            <span className="text">I accept.</span>
                                            <span>
                                                <input type="checkbox" onClick={this.toggleHandler} />
                                                <span className="checkmark"></span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                
                        </div>          
                        <div className="text-right">
                            <Link to={`/eligibility/${this.props.match.params.contary}/step2`} type="button" className="btn btn-back mr-2 bg-white" onClick={this.pageChangeHandler}>Back</Link>
                            <button  type="button" className="btn btn-apply" disabled={this.state.disable} onClick={this.submitForm}>Submit</button>                            
                        </div>
                 </form>
                  
        </div>
    )
   }
}
const mapStateToProps = state=>{
    return {
        person: state.person, 
    };
}
const mapDispatchToProps = dispatch => {   
    return {
        onSetLoader:   ()=>dispatch({type: 'SET_LOADER'}),
        onSetFile:     (dataFile)=>dispatch({type: 'FILE_HANDLER', dataFile: dataFile})
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Document));